import { calculateTableData } from "../../src/utils/calculationFunctions";

// Action types
export const SET_PROCESSPOINT = " SET_PROCESSPOINT";
export const ADD_PROCESSPOINT = "ADD_PROCESSPOINT";
//export const ADD_HEATINGPROCESSPOINT = "ADD_HEATINGPROCESSPOINT";
//export const ADD_COOLINGPROCESSPOINT = "ADD_COOLINGPROCESSPOINT";
//export const ADD_MIXINGPROCESSPOINT = "ADD_MIXINGPROCESSPOINT";

export const UPDATE_PROCESSPOINT = "UPDATE_PROCESSPOINT";
export const UPDATE_INDOORPOINT = "UPDATE_INDOORPOINT";
export const UPDATE_OUTDOORPOINT = "UPDATE_OUTDOORPOINT";
export const GET_INDOORPOINT = "GET_INDOORPOINT";
export const GET_OUTDOORPOINT = "GET_OUTDOORPOINT";
export const GET_LASTPROCESSPOINT = " GET_LASTPROCESSPOINT";
export const GET_LASTTWOPROCESSPOINT = " GET_LASTTWOPROCESSPOINT";
export const GET_ARRAY_LENGHT = "GET_ARRAY_LENGHT";
export const GET_ARRAY_DATA = "GET_ARRAY_DATA";
export const ADD_NEW_SUMMER_PROCESSPOINT = "ADD_NEW_SUMMER_PROCESSPOINT";
export const ADD_OR_UPDATE_HEATINGPOINT = "ADD_OR_UPDATE_HEATINGPOINT";
export const ADD_OR_UPDATE_COOLINGPOINT = "ADD_OR_UPDATE_COOLINGPOINT";
export const ADD_OR_UPDATE_MIXINGPOINT = "ADD_OR_UPDATE_MIXINGPOINT";
export const ADD_OR_UPDATE_STEAMHUMIDITYPOINT =
  "ADD_OR_UPDATE_STEAMHUMIDITYPOINT";
export const CHANGE_OUTDOOR_POINT = "CHANGE_OUTDOOR_POINT";
export const CHANGE_INDOOR_POINT = "CHANGE_INDOOR_POINT";
export const CHANGE_POINT_PROCESS = "CHANGE_POINT_PROCESS";
export const ADD_DLL_EHA_POINT = "ADD_DLL_EHA_POINT";
export const ADD_DLL_SUP_POINT = "ADD_DLL_SUP_POINT";
export const ADD_COOLER_SUP_POINT = "ADD_COOLER_SUP_POINT";
export const ADD_COOLER_EHA_POINT = "ADD_COOLER_EHA_POINT";
export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
export const DELETE_PROCESS_POINT = "DELETE_PROCESS_POINT";
export const UPDATE_AIRFLOW = "UPDATE_AIRFLOW";

// Create Redux action creators that return an action
/*export const setProcessPoint = ({
  temperatureDryBulb,
  temperatureWetBulb,
  temperatureDewPoint,
  relativeHumidity,
  absoluteHumidity,
  enthalpy,
  airFlowHours,
  airFlowSeconds,
  massFlow,
  realFlow,
  airDensity,
  usedPower,
  usedWater,
  process,
}) => {
  //update first points with values from position
  //

  const newPoint = 0;
  return {
    type: SET_PROCESSPOINT,
    payload: newPoint,
  };
};*/
export const setInitialState = () => {
  return { type: SET_INITIAL_STATE };
};
export const addNewSummerProcessPoint = () => {
  return { type: ADD_NEW_SUMMER_PROCESSPOINT };
};
export const changePointProcess = (processName, processID) => {
  return {
    type: CHANGE_POINT_PROCESS,
    payload: { processName, processID },
  };
};
export const deleteProcessPoint = (processID) => {
  return {
    type: DELETE_PROCESS_POINT,
    payload: processID,
  };
};
export const updateAirflow = (airFlow, airFlowUnit, mixingRatio) => {
  return {
    type: UPDATE_AIRFLOW,
    payload: { airFlow, airFlowUnit, mixingRatio },
  };
};

export const updateOutdoorPoint = (
  temperatureDryBulb,
  temperatureWetBulb,
  temperatureDewPoint,
  relativeHumidity,
  elevation,
  airFlowHours
) => {
  //menja prvu tacku u nizu i popunjava je podacima iz project item-a
  //pozivaju se funkcije za kalkulacije parametara apsolutna vlaznost, entalpija, gustina, protok, maseni pritisak
  //kreira se novi objekat koji ce zameniti prvu tacku sa inicijalnim vrednostima

  const {
    absoluteHumidity,
    enthalpy,
    massFlow,
    realFlow,
    airDensity,
    temperatureWetBulbCalculated,
  } = calculateTableData(
    temperatureDryBulb,
    temperatureWetBulb,
    temperatureDewPoint,
    relativeHumidity,
    elevation,
    airFlowHours
  );

  const newPoint = {
    temperatureDryBulb: temperatureDryBulb,
    temperatureWetBulb: temperatureWetBulb,
    temperatureDewPoint: temperatureDewPoint,
    relativeHumidity: relativeHumidity,
    absoluteHumidity: absoluteHumidity,
    enthalpy: enthalpy,
    airFlowHours: airFlowHours,
    airFlowSeconds: airFlowHours / 3600,
    massFlow: massFlow,
    realFlow: realFlow,
    airDensity: airDensity,
    usedPower: 0,
    usedWater: 0,
    process: "outdoor",
  };
  return {
    type: UPDATE_OUTDOORPOINT,
    payload: newPoint,
  };
};
/*export const getOutdoorPoint = () => {
  return { type: GET_OUTDOORPOINT };
};*/
export const updateIndoorPoint = (
  temperatureDryBulb,
  temperatureWetBulb,
  temperatureDewPoint,
  relativeHumidity,
  elevation,
  airFlowHours
) => {
  //menja prvu tacku u nizu i popunjava je podacima iz project item-a koji su prosledjeni kao payload
  //pozivaju se funkcije za kalkulacije parametara apsolutna vlaznost, entalpija, gustina, protok, maseni pritisak
  //kreira se novi objekat koji ce zameniti prvu tacku sa inicijalnim vrednostima
  const {
    absoluteHumidity,
    enthalpy,
    massFlow,
    realFlow,
    airDensity,
    temperatureWetBulbCalculated,
  } = calculateTableData(
    temperatureDryBulb,
    temperatureWetBulb,
    temperatureDewPoint,
    relativeHumidity,
    elevation,
    airFlowHours
  );

  const newPoint = {
    id: 1,
    temperatureDryBulb: temperatureDryBulb,
    temperatureWetBulb: temperatureWetBulbCalculated,
    temperatureDewPoint: temperatureDewPoint,
    relativeHumidity: relativeHumidity,
    absoluteHumidity: absoluteHumidity,
    enthalpy: enthalpy,
    airFlowHours: airFlowHours,
    airFlowSeconds: airFlowHours / 3600,
    massFlow: massFlow,
    realFlow: realFlow,
    airDensity: airDensity,
    usedPower: 0,
    usedWater: 0,
    process: "indoor",
  };
  return {
    type: UPDATE_INDOORPOINT,
    payload: newPoint,
  };
};
/*export const getIndoorPoint = () => {
  return { type: GET_INDOORPOINT };
};*/

export const addOrUpdateHeatingPoint = (
  heatingTemperature,
  elevation,
  processID
) => {
  return {
    type: ADD_OR_UPDATE_HEATINGPOINT,
    payload: { heatingTemperature, elevation, processID },
  };
};
export const addOrUpdateCoolingPoint = (
  coolingTemperature,
  P,
  airFlowHours,
  airFlowSeconds,
  coolerTemperature,
  elevation,
  maxHumidityInProcess,
  processID
) => {
  return {
    type: ADD_OR_UPDATE_COOLINGPOINT,
    payload: {
      coolingTemperature,
      P,
      airFlowHours,
      airFlowSeconds,
      coolerTemperature,
      elevation,
      maxHumidityInProcess,
      processID,
    },
  };
};
export const addOrUpdateMixingPoint = (elevation, processID) => {
  return {
    type: ADD_OR_UPDATE_MIXINGPOINT,
    payload: { elevation, processID },
  };
};
export const addOrUpdateSteamHumidifyPoint = (
  relativeHumidity,
  elevation,
  processID
) => {
  return {
    type: ADD_OR_UPDATE_STEAMHUMIDITYPOINT,
    payload: { relativeHumidity, elevation, processID },
  };
};

export const changeOutdoorPoint = (fieldName, value) => {
  return {
    type: CHANGE_OUTDOOR_POINT,
    payload: { fieldName, value },
  };
};
export const changeIndoorPoint = (fieldName1, value1) => {
  return {
    type: CHANGE_INDOOR_POINT,
    payload: { fieldName1, value1 },
  };
};

export const getArrayData = () => {
  //returns array length of current state
  return {
    type: GET_ARRAY_DATA,
  };
};

export const updateDLLEhaPoint = (
  temperatureDryBulb,

  relativeHumidity,
  elevation,
  airFlowHours
) => {
  //menja prvu tacku u nizu i popunjava je podacima iz project item-a koji su prosledjeni kao payload
  //pozivaju se funkcije za kalkulacije parametara apsolutna vlaznost, entalpija, gustina, protok, maseni pritisak
  //kreira se novi objekat koji ce zameniti prvu tacku sa inicijalnim vrednostima

  const {
    absoluteHumidity,
    enthalpy,
    massFlow,
    realFlow,
    airDensity,
    temperatureWetBulbCalculated,
  } = calculateTableData(
    +temperatureDryBulb,
    0,
    0,
    +relativeHumidity,
    +elevation,
    +airFlowHours
  );
  console.log(absoluteHumidity, enthalpy, massFlow, realFlow, airDensity);

  const newPoint = {
    temperatureDryBulb: +temperatureDryBulb,
    temperatureWetBulb: temperatureWetBulbCalculated,
    temperatureDewPoint: 0,
    relativeHumidity: +relativeHumidity,
    absoluteHumidity: absoluteHumidity,
    enthalpy: enthalpy,
    airFlowHours: airFlowHours,
    airFlowSeconds: airFlowHours / 3600,
    massFlow: massFlow,
    realFlow: realFlow,
    airDensity: airDensity,
    usedPower: 0,
    usedWater: 0,
    process: "DLL point",
  };

  return {
    type: ADD_DLL_EHA_POINT,
    payload: newPoint,
  };
};

export const updateDLLSupPoint = (
  temperatureDryBulb,

  relativeHumidity,
  elevation,
  airFlowHours
) => {
  //menja prvu tacku u nizu i popunjava je podacima iz project item-a koji su prosledjeni kao payload
  //pozivaju se funkcije za kalkulacije parametara apsolutna vlaznost, entalpija, gustina, protok, maseni pritisak
  //kreira se novi objekat koji ce zameniti prvu tacku sa inicijalnim vrednostima

  const {
    absoluteHumidity,
    enthalpy,
    massFlow,
    realFlow,
    airDensity,
    temperatureWetBulbCalculated,
  } = calculateTableData(
    +temperatureDryBulb,
    0,
    0,
    +relativeHumidity,
    +elevation,
    +airFlowHours
  );

  const newPoint = {
    temperatureDryBulb: +temperatureDryBulb,
    temperatureWetBulb: temperatureWetBulbCalculated,
    temperatureDewPoint: 0,
    relativeHumidity: +relativeHumidity,
    absoluteHumidity: absoluteHumidity,
    enthalpy: enthalpy,
    airFlowHours: airFlowHours,
    airFlowSeconds: airFlowHours * 60,
    massFlow: massFlow,
    realFlow: realFlow,
    airDensity: airDensity,
    usedPower: 0,
    usedWater: 0,
    process: "DLL point",
  };

  return {
    type: ADD_DLL_SUP_POINT,
    payload: newPoint,
  };
};

export const updateCoolerSupPoint = (
  temperatureDryBulb,

  relativeHumidity,
  elevation,
  airFlowHours
) => {
  //menja prvu tacku u nizu i popunjava je podacima iz project item-a koji su prosledjeni kao payload
  //pozivaju se funkcije za kalkulacije parametara apsolutna vlaznost, entalpija, gustina, protok, maseni pritisak
  //kreira se novi objekat koji ce zameniti prvu tacku sa inicijalnim vrednostima

  const {
    absoluteHumidity,
    enthalpy,
    massFlow,
    realFlow,
    airDensity,
    temperatureWetBulbCalculated,
  } = calculateTableData(
    +temperatureDryBulb,
    0,
    0,
    +relativeHumidity,
    +elevation,
    +airFlowHours
  );

  const newPoint = {
    temperatureDryBulb: temperatureDryBulb,
    temperatureWetBulb: temperatureWetBulbCalculated,
    temperatureDewPoint: 0,
    relativeHumidity: relativeHumidity,
    absoluteHumidity: absoluteHumidity,
    enthalpy: enthalpy,
    airFlowHours: airFlowHours,
    airFlowSeconds: airFlowHours * 60,
    massFlow: massFlow,
    realFlow: realFlow,
    airDensity: airDensity,
    usedPower: 0,
    usedWater: 0,
    process: "Cooler point",
  };

  return {
    type: ADD_COOLER_SUP_POINT,
    payload: newPoint,
  };
};

export const updateCoolerEhaPoint = (
  temperatureDryBulb,

  relativeHumidity,
  elevation,
  airFlowHours
) => {
  //menja prvu tacku u nizu i popunjava je podacima iz project item-a koji su prosledjeni kao payload
  //pozivaju se funkcije za kalkulacije parametara apsolutna vlaznost, entalpija, gustina, protok, maseni pritisak
  //kreira se novi objekat koji ce zameniti prvu tacku sa inicijalnim vrednostima

  const {
    absoluteHumidity,
    enthalpy,
    massFlow,
    realFlow,
    airDensity,
    temperatureWetBulbCalculated,
  } = calculateTableData(
    +temperatureDryBulb,
    0,
    0,
    +relativeHumidity,
    +elevation,
    +airFlowHours
  );
  console.log(absoluteHumidity, enthalpy, massFlow, realFlow, airDensity);

  const newPoint = {
    temperatureDryBulb: temperatureDryBulb,
    temperatureWetBulb: temperatureWetBulbCalculated,
    temperatureDewPoint: 0,
    relativeHumidity: relativeHumidity,
    absoluteHumidity: absoluteHumidity,
    enthalpy: enthalpy,
    airFlowHours: airFlowHours,
    airFlowSeconds: airFlowHours / 3600,
    massFlow: massFlow,
    realFlow: realFlow,
    airDensity: airDensity,
    usedPower: 0,
    usedWater: 0,
    process: "Cooler point",
  };

  return {
    type: ADD_COOLER_EHA_POINT,
    payload: newPoint,
  };
};
